module.exports = __webpack_public_path__ + "static/img/clqd1.a68cc6e6.png";